import React from 'react';
import { createArray } from '../_utils';
import './Details.css';
var DetailsSkeleton = function () { return (React.createElement("table", { className: "sattributegrid" },
    React.createElement("tbody", null, createArray(5).map(function (i) { return (React.createElement("tr", { key: i },
        React.createElement("th", { className: "details-label skeleton-line skeleton-h-xl skeleton-w-lg d-inline-block align-bottom mr-2" }),
        React.createElement("td", { className: "details-value skeleton-line skeleton-h-xl skeleton-w-xl d-inline-block align-bottom mr-2" }))); })))); };
export default React.memo(DetailsSkeleton);
